import type { PRISMIC_ZONE_LAYOUT } from '@/app/constants/zone';
import type { Game, GameTrackingInfo } from '@/types/games';
import type { GameViewModel } from '@/types/games/game-view-model';
import { adaptGames, adaptGameTrackingInfo } from '@/logic/game-adapter/adapt-game';
import type { AdaptGameOptions } from '@/logic/game-adapter/adapt-game';

export type ZoneGamesData = {
    games: GameViewModel[];
    tracking: GameTrackingInfo[];
};

export const getZoneGames = (
    rawGames: Game[],
    gridLayout: PRISMIC_ZONE_LAYOUT,
    options?: Omit<AdaptGameOptions, 'gridLayoutCtx'>
): ZoneGamesData => {
    const games = adaptGames(rawGames, gridLayout, options);
    const tracking: GameTrackingInfo[] = rawGames.map((game, index) => ({
        ...adaptGameTrackingInfo(game),
        gameTileType: games[index]?.animatedTileVideoUrl ? 'animated' : 'static'
    }));

    return { games, tracking };
};
